import React, { useEffect, useState } from 'react';
import { useApiClient } from '@marageti/z4-lib';
import { useSnackbar } from 'notistack';
import NewsletterSignupView from './newsletter-signup-view';
import { useAuthStore } from '../../store';

const NewsletterSignupContainer = () => {
  const { enqueueSnackbar } = useSnackbar();
  const apiClient = useApiClient();
  const { loggedInTraveler } = useAuthStore();
  const [hide, setHide] = useState(true);

  useEffect(() => {
    //  Hide the newsletter signup if the user is already subscribed
    if (loggedInTraveler) {
      apiClient.activeCampaignClient.getActiveCampaignContact(loggedInTraveler.email)
        .then(() => setHide(true))
        .catch(() => setHide(false));
    }
  }, [loggedInTraveler]);

  const onSubmit = async () => {
    try {
      await apiClient.activeCampaignClient.postActiveCampaignRequest({
        fullName: loggedInTraveler?.fullName,
        email: loggedInTraveler?.email,
      });
      enqueueSnackbar('Successfully subscribed to newsletter.', { variant: 'success' });
      setHide(true);
    } catch (error: any) {
      enqueueSnackbar('Failed to subscribe to newsletter.', { variant: 'default' });
    }
  };

  return hide ? null : (
    <NewsletterSignupView
      onSubmit={onSubmit}
    />
  );
};

export default NewsletterSignupContainer;
